import { getWindowLoad } from './performanceListener';

const onWindowOnLoad = response => {
  getWindowLoad().then(windowLoad => response(windowLoad));
};

export default onWindowOnLoad;
